import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import SecureFormItem from "@/common/SecureFormItem";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { SCHEMA_NAME } from "@/util/common_variable";
import { Button, Form } from "antd";
import { useEffect } from "react";

const SkillsCertificationsModal = ({
  show,
  handleCancel,
  formSubmit,
  selectSkill,
  bookingsFieldsEnabled = true,
  startingPoint = "",
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isNonEmptyVariable(selectSkill)) {
      form.setFieldsValue(selectSkill);
    } else {
      form.resetFields();
    }
  }, [selectSkill]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const data = {
        ...values,
        scheduledDate: isNonEmptyVariable(values?.scheduledDate)
          ? values?.scheduledDate?.format("MM/DD/YYYY")
          : null,
        completedDate: isNonEmptyVariable(values?.completedDate)
          ? values?.completedDate?.format("MM/DD/YYYY")
          : null,
        certificationDate: isNonEmptyVariable(values?.certificationDate)
          ? values?.certificationDate?.format("MM/DD/YYYY")
          : null,
      };
      formSubmit(data);
      form.resetFields();
    });
  };
  function handleFormCancel() {
    handleCancel();
    form.resetFields();
  }
  return (
    <>
      <Modal
        show={show}
        header={`${selectSkill ? "VIEW" : "ADD"} Skills & Certificates`}
        onHide={handleFormCancel}
        handleCancel={handleFormCancel}
        handleSubmit={handleSubmit}
        designPattern="ant"
        width="75%"
        footerActions={[
          <Button
            key="SUBMIT"
            onClick={handleFormCancel}
            disabled={!bookingsFieldsEnabled}
          >
            Close
          </Button>,
          <Button
            key="SUBMIT"
            onClick={handleSubmit}
            disabled={!bookingsFieldsEnabled}
          >
            Save
          </Button>,
        ]}
        // submitButtonDisabled={!bookingsFieldsEnabled}
      >
        <FieldSecurityProvider
          entity={SCHEMA_NAME.SKILLS}
          startingPoint={startingPoint}
          bookingsFieldsEnabled={bookingsFieldsEnabled}
        >
          <Form form={form} disabled={!bookingsFieldsEnabled}>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol lg={18}>
                <SecureFormItem
                  fieldName="skillName"
                  formItemProps={{ name: "skillName", label: "Skill Name" }}
                >
                  <Select
                    id="skillName"
                    options={getOptionsFromRefList("Staff_Skill_Name")}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol lg={6}>
                <SecureFormItem
                  fieldName="skillLevel"
                  formItemProps={{ name: "skillLevel", label: "Skill Level" }}
                >
                  <Select
                    id="skillLevel"
                    options={getOptionsFromRefList("Staff_Skill_Level")}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol lg={24}>
                <SecureFormItem
                  fieldName="skillDesc"
                  formItemProps={{
                    name: "skillDesc",
                    label: "Skill Description",
                  }}
                >
                  <TextField id="skillDescription" inputType="textarea" />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol lg={9}>
                <SecureFormItem
                  fieldName="trainingName"
                  formItemProps={{ name: "trainingName", label: "Training" }}
                >
                  <TextField id="training" />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol lg={6}>
                <SecureFormItem
                  fieldName="scheduledDate"
                  formItemProps={{
                    name: "scheduledDate",
                    label: "Scheduled Date",
                  }}
                >
                  <CommonDatePicker
                    id="scheduledDate"
                    format="MM/DD/YYYY"
                    showTime={false}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol lg={6}>
                <SecureFormItem
                  fieldName="completedDate"
                  formItemProps={{
                    name: "completedDate",
                    label: "Completed Date",
                  }}
                >
                  <CommonDatePicker
                    id="completedDate"
                    format="MM/DD/YYYY"
                    showTime={false}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol lg={3}>
                <SecureFormItem
                  fieldName="trainingHours"
                  formItemProps={{ name: "trainingHours", label: "Hours" }}
                >
                  <TextField id="hours" type="number" />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol lg={24}>
                <SecureFormItem
                  fieldName="trainingDesc"
                  formItemProps={{
                    name: "trainingDesc",
                    label: "Training Description",
                  }}
                >
                  <TextField id="trainingDescription" inputType="textarea" />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol lg={14}>
                <SecureFormItem
                  fieldName="certificationName"
                  formItemProps={{
                    name: "certificationName",
                    label: "Certificate",
                  }}
                >
                  <TextField id="certificate" />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol lg={6}>
                <SecureFormItem
                  fieldName="certificationDate"
                  formItemProps={{
                    name: "certificationDate",
                    label: "Date Received",
                  }}
                >
                  <CommonDatePicker
                    id="dateReceived"
                    format="MM/DD/YYYY"
                    showTime={false}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol lg={4}>
                <SecureFormItem
                  fieldName="certificationHours"
                  formItemProps={{ name: "certificationHours", label: "Hours" }}
                >
                  <TextField id="certificateHours" type="number" />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol lg={24}>
                <SecureFormItem
                  fieldName="certificationDesc"
                  formItemProps={{
                    name: "certificationDesc",
                    label: "Certificate Description",
                  }}
                >
                  <TextField id="certificateDescription" inputType="textarea" />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
          </Form>
        </FieldSecurityProvider>
      </Modal>
    </>
  );
};

export default SkillsCertificationsModal;
